export default "__VITE_ASSET__BpgHSEcP__"